module.exports = window.top.seamlessStore;